export default "__VITE_ASSET__M7bx$MOe__"